import { render, staticRenderFns } from "./TakipOncesiTaslak.vue?vue&type=template&id=7c367db8"
import script from "./TakipOncesiTaslak.vue?vue&type=script&lang=ts"
export * from "./TakipOncesiTaslak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports